"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionById = exports.documentOutline = exports.Section = void 0;
const slate_1 = require("slate");
function paragraphHeadingLevel(namedStyleType) {
    switch (namedStyleType) {
        case 'TITLE':
            return 7;
        case 'SUBTITLE':
            return 0;
        case 'HEADING_1':
            return 6;
        case 'HEADING_2':
            return 5;
        case 'HEADING_3':
            return 4;
        case 'HEADING_4':
            return 3;
        case 'HEADING_5':
            return 2;
        case 'HEADING_6':
            return 1;
        case 'NORMAL_TEXT':
        default:
            return 0;
    }
}
exports.Section = {
    /**
     * Print section titles as string for debugging purposes
     */
    toString: (section) => {
        const indentation = '  '.repeat(paragraphHeadingLevel('TITLE') - section.level);
        const titleString = slate_1.Node.string(section.title);
        const { headingId } = section.title;
        const blocksCount = section.endIndex - section.startIndex;
        return [
            `\n${indentation}[${headingId}] ${titleString} (${blocksCount} blocks)`,
            ...section.children.map(exports.Section.toString),
        ].join('');
    },
    isAncestor(ancestor, descendent) {
        return ancestor.startIndex < descendent.startIndex && ancestor.endIndex >= descendent.endIndex;
    },
    getAncestorsInclusive(section) {
        const result = [];
        let iterator = section;
        while (iterator != null) {
            result.push(iterator);
            iterator = iterator.parent;
        }
        return result;
    },
    getDescendentsInclusive(section) {
        const result = [section];
        section.children.forEach((child) => {
            result.push(...exports.Section.getDescendentsInclusive(child));
        });
        return result;
    },
    getLowestCommonAncestor(a, b) {
        const aAncestors = exports.Section.getAncestorsInclusive(a);
        const bAncestors = exports.Section.getAncestorsInclusive(b);
        const minLength = Math.min(aAncestors.length, bAncestors.length);
        let i = 1;
        while (i <= minLength && aAncestors[aAncestors.length - i] === bAncestors[bAncestors.length - i]) {
            i = i + 1;
        }
        return aAncestors[aAncestors.length - i + 1];
    },
};
function documentOutline(nodes) {
    const resultParent = {
        title: { type: 'paragraph', children: [] },
        parent: null,
        level: Infinity,
        startIndex: 0,
        endIndex: 0,
        children: [],
    };
    let currentLeaf = resultParent;
    nodes.forEach((node, index) => {
        const nodeHeadingLevel = node.type === 'paragraph' ? paragraphHeadingLevel(node.namedStyleType) : 0;
        if (node.type === 'paragraph' && nodeHeadingLevel > 0) {
            // close active headings if the current node has `>= level`
            while (currentLeaf.level <= nodeHeadingLevel && currentLeaf.parent != null) {
                currentLeaf = currentLeaf.parent;
            }
            const newSection = {
                title: node,
                parent: currentLeaf,
                level: nodeHeadingLevel,
                startIndex: index,
                endIndex: index,
                children: [],
            };
            currentLeaf.children.push(newSection);
            currentLeaf = newSection;
        }
        let currentNode = currentLeaf;
        while (currentNode != null) {
            currentNode.endIndex = index + 1;
            currentNode = currentNode.parent;
        }
    });
    return resultParent.children;
}
exports.documentOutline = documentOutline;
function sectionById(nodes, { headingId }) {
    const outline = documentOutline(nodes);
    const findNode = (sections, headingId) => {
        for (const section of sections) {
            if (section.title.headingId === headingId) {
                return section;
            }
            const node = findNode(section.children, headingId);
            if (node != null) {
                return node;
            }
        }
        return null;
    };
    const section = findNode(outline, headingId);
    if (section != null) {
        return {
            title: nodes[section.startIndex],
            body: nodes.slice(section.startIndex + 1, section.endIndex),
        };
    }
    else {
        return null;
    }
}
exports.sectionById = sectionById;
//# sourceMappingURL=documentOutline.js.map